import { getToken } from "../../utils/auth";
import { dev_baseUrl } from "../../utils/var";

export const SaveAttachments = async (formData,navigate) => {
  const accesstoken = getToken();
  let data ='';
  if (accesstoken) {
    try {                  
      const response = await fetch(`${dev_baseUrl}/Media/upload`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,          
        },
        body: formData,
      });
      
      data = await response.json();
      
   if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
      } else{
        return data;
      }
    } catch (error) {
      console.error('Network error:', error);
      return { form: 'An error occurred. Please try again later.', data };
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.', data };
  }
};
